import {Component, OnInit,Injectable, Inject} from 'ng-metadata/core';
import {TagsSearchBarService} from './tagsSearchBar.service';
import {TagsService} from '../tags.service';

@Component({
    selector: 'prm-tags-search-bar',
    templateUrl: 'components/tags/tagsSearchBar/tags-search-bar.html',
})

export class PrmTagsSearchBar{
    public mainSearchField: string;
    constructor(private tagsService: TagsService,
                private tagsSearchBarService: TagsSearchBarService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element) {
    }

    ngOnInit(){
        this.$scope.$watch(()=>this.mainSearchField, (newVal,oldVal)=>{
            this.$timeout(() => {
                this.removeAriaLabel('md-input-container input');
            }, 400);
        });
    }

    /*
    performs a tags search containing the mainSearchField
    */
    public doTagsSearch(){
        if(this.mainSearchField.length === 0){
            this.tagsService.isInSearch = false;
        }
        else{
            this.tagsService.isInSearch = true;
        }
        this.tagsService.doTagsSearch(this.mainSearchField);
    }

    //this function remove aria-label from search edit field.
    private removeAriaLabel(str){
        let searchEditField: [Element]= this.$element[0].querySelectorAll(str);
            for(let input of searchEditField){
                input.removeAttribute('aria-label');
            }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsSearchBar/tagsSearchBar.directive.ts